<mat-card class="m-2 p-0">  
    <div class="table-wrapper"> 
        <table mat-table [dataSource]="dataSource" matSort class="w-100"> 
            
            <!-- Image Column -->
            <ng-container matColumnDef="image">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Image </th>
                <td mat-cell *matCellDef="let follower"> <img [src]="follower.image" alt="user" width="60" class="d-block"> </td>
            </ng-container> 

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let follower"> {{ follower.name}} </td>
            </ng-container> 

            <!-- Orders Column -->
            <ng-container matColumnDef="orders">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Orders </th>
                <td mat-cell *matCellDef="let follower"> {{follower.orders}} </td>
            </ng-container>  

            <!-- Remove Column -->
            <ng-container matColumnDef="remove">
                <th mat-header-cell *matHeaderCellDef> Remove </th>
                <td mat-cell *matCellDef="let follower">   
                    <button mat-icon-button color="warn" (click)="remove(follower)" matTooltip="Remove">
                        <mat-icon>delete</mat-icon>
                    </button>   
                </td>
            </ng-container>  
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let follower; columns: displayedColumns;"></tr>
        </table> 
        <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">No data available</p> 
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
</mat-card>